import React from "react";
import Select from "react-select";
import Button from "./Button";
import classNames from "classnames";

class AutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
    };
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleButtonSubmit = this.handleButtonSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
  }

  handleChangeSelect(name, value) {
    this.props.handleChange({ target: { value, name } });
  }

  handleButtonSubmit() {
    this.props.handleChange({
      target: { value: this.state.input, name: this.props.name },
    });
    this.setState({
      input: "",
    });
  }

  handleChangeInput(e) {
    let value = e.target.value;

    this.setState({
      input: value,
    });
  }

  render() {
    const classname = this.props.form ? "form-group" : "";
    
    // Mesclar estilos customizados com os estilos padrão
    const defaultStyles = {
      menuPortal: (base) => ({ ...base, zIndex: 9999 })
    };
    
    const customStyles = this.props.customStyles || {};
    const mergedStyles = {
      ...defaultStyles,
      ...customStyles,
      control: (base, state) => {
        const customControl = customStyles.control 
          ? customStyles.control(base, state)
          : base;
        return {
          ...customControl,
          ...(this.props.style && this.props.style.border 
            ? { border: this.props.style.border }
            : {})
        };
      }
    };

    return (
      <div className={classNames(classname, "selectBox")}>
        {this.props.title ? (
          <label for={this.props.name}> {this.props.title} </label>
        ) : null}
        {this.props.type === "input" ? (
          <div>
            <input
              type="text"
              value={this.state.input}
              onChange={this.handleChangeInput}
            />
            <Button
              action={this.handleButtonSubmit}
              type={"primary"}
              title={"+"}
            />
          </div>
        ) : (
          <Select
            menuPosition={"fixed"}
            menuPortalTarget={document.body}
            styles={mergedStyles}
            name={this.props.name}
            value={this.props.value}
            onChange={(value) =>
              this.handleChangeSelect(this.props.name, value)
            }
            options={this.props.options}
            formatOptionLabel={this.props.formatOptionLabel}
            isDisabled={this.props.disabled}
          />
        )}
      </div>
    );
  }
}

export default AutoComplete;
